import { render, staticRenderFns } from "./OsymQuotaSelectbox.vue?vue&type=template&id=25cfe2e3"
import script from "./OsymQuotaSelectbox.vue?vue&type=script&lang=js"
export * from "./OsymQuotaSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports